import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: 'General',
      questions: [
        {
          q: 'What is Flippy Homes?',
          a: 'Flippy Homes is South Africa\'s trusted property marketplace where you can find properties for sale and rent, connect with real estate agents, and discover verified home service contractors.'
        },
        {
          q: 'Is Flippy Homes free to use?',
          a: 'Yes! Browsing properties and contacting agents is completely free. Agents and property owners can list properties with our subscription plans starting from R199/month.'
        },
        {
          q: 'How do I contact Flippy Homes?',
          a: 'You can reach us via WhatsApp at +27 65 524 9286 or email us at info@flippyhomes.co.za. We\'re also active on Facebook and TikTok.'
        }
      ]
    },
    {
      category: 'For Property Seekers',
      questions: [
        {
          q: 'How do I search for properties?',
          a: 'Use our advanced search feature to filter by province, city, property type, price range, bedrooms, and more. You can also save your searches and get notifications.'
        },
        {
          q: 'How do I contact an agent or property owner?',
          a: 'Each listing has a WhatsApp button that allows you to message the agent or owner directly. You can also call using the contact number provided.'
        },
        {
          q: 'Can I report a suspicious listing?',
          a: 'Yes! Click the "Report" button on any listing to flag it for review. Our team will investigate and take appropriate action.'
        }
      ]
    },
    {
      category: 'For Agents & Owners',
      questions: [
        {
          q: 'How do I list my property?',
          a: 'Create an account, choose your subscription plan, and click "New Listing" to add your property. You can upload multiple images, videos, and provide detailed specifications.'
        },
        {
          q: 'What are the subscription costs?',
          a: 'We offer different plans: Basic at R199/month for private owners, Standard at R299/month for agents, and Premium plans with additional features. All plans include a 1-month free trial.'
        },
        {
          q: 'How many images can I upload per listing?',
          a: 'You can upload up to 20 high-quality images per listing. Images are automatically enhanced for professional quality.'
        }
      ]
    },
    {
      category: 'For Contractors',
      questions: [
        {
          q: 'How do I register as a contractor?',
          a: 'Create an account, select "Home Services Contractor" as your role, and complete the registration wizard with your business details and verification documents.'
        },
        {
          q: 'What documents are required for verification?',
          a: 'We require a valid SA ID. Optional documents include CIPC company registration and trade certificates to enhance your profile credibility.'
        },
        {
          q: 'How much does a contractor subscription cost?',
          a: 'R150/month with a 1-month free trial. This gives you visibility in our Home Services directory and allows clients to contact you directly.'
        }
      ]
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  let globalIndex = 0;

  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          Frequently Asked Questions
        </h1>
        <p className="text-gray-600 mb-8">Find answers to common questions about Flippy Homes</p>

        {faqs.map((category, catIndex) => (
          <div key={catIndex} className="mb-8">
            <h2 className="text-xl font-semibold text-emerald-700 mb-4">{category.category}</h2>
            <div className="space-y-3">
              {category.questions.map((faq, qIndex) => {
                const currentIndex = globalIndex++;
                return (
                  <Card key={qIndex} className="overflow-hidden">
                    <button
                      onClick={() => toggleFAQ(currentIndex)}
                      className="w-full p-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-medium text-gray-800 pr-4">{faq.q}</span>
                      <i className={`fas fa-chevron-down text-emerald-600 transition-transform ${
                        openIndex === currentIndex ? 'rotate-180' : ''
                      }`}></i>
                    </button>
                    {openIndex === currentIndex && (
                      <CardContent className="pt-0 pb-4 px-4 border-t bg-gray-50">
                        <p className="text-gray-600">{faq.a}</p>
                      </CardContent>
                    )}
                  </Card>
                );
              })}
            </div>
          </div>
        ))}

        <Card className="bg-emerald-600 text-white">
          <CardContent className="p-6 text-center">
            <h3 className="text-xl font-semibold mb-2">Still have questions?</h3>
            <p className="mb-4 opacity-90">Our team is here to help!</p>
            <a 
              href="https://wa.me/27655249286" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white text-emerald-600 px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors"
            >
              <i className="fab fa-whatsapp"></i>
              Chat with us on WhatsApp
            </a>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default FAQPage;
